import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import BaseState from "interfaces/state/BaseState";
import Invoice from "interfaces/response/Invoice";
import { getInvoicesAsync, getUserDefaultPaymentCardDetail } from "apis/InvoiceApi";
import PaymentCard from "interfaces/response/PaymentCard";

interface InvoiceState extends BaseState {
  invoices: Invoice[];
  invoiceCardDetail: PaymentCard | null;
}

const initialState: InvoiceState = {
  loading: false,
  invoices: [],
  invoiceCardDetail: null,
};

export const getInvoices = createAsyncThunk(
  "invoice/getInvoices",
  async (subscriptionId: number, thunkAPI) => {
    return await getInvoicesAsync(subscriptionId);
  }
);

export const getDefaultPaymentCardDetail = createAsyncThunk(
  "invoice/getDefaultPaymentCardDetail",
  async () => {
    return await getUserDefaultPaymentCardDetail();
  }
);

export const invoiceSlice = createSlice({
  name: "invoice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getInvoices.pending, (state, action) => {
      state.invoices = [];
      state.loading = true;
    });
    builder.addCase(getInvoices.fulfilled, (state, action) => {
      state.loading = false;
      state.invoices = action.payload;
    });
    builder.addCase(getInvoices.rejected, (state, action) => {
      state.loading = false;
    });
    builder.addCase(getDefaultPaymentCardDetail.pending, (state, action) => {
      state.loading = true;
    });
    builder.addCase(getDefaultPaymentCardDetail.fulfilled, (state, action) => {
      state.loading = false;
      state.invoiceCardDetail = action.payload;
    });
    builder.addCase(getDefaultPaymentCardDetail.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export default invoiceSlice.reducer;
